import { SimulationStatusTypes } from '../../constants/constants';

export function getElements(simulationEvents, selectedSimulationRuntime) {
  let graph = [];
  setDependencies();
  for (const key in defaultNodes) {
    let node = defaultNodes[key];
    let events = findMatchingEvents(node, simulationEvents);
    const nodeText = getNodeText(node, selectedSimulationRuntime);
    graph.push({data: {id: nodeText, color: getColor(events), events}});
    if (node.dependencies) {
      for (const dependencyIndex in node.dependencies) {
        const dependency = node.dependencies[dependencyIndex];
        const dependencyText = getNodeText(dependency, selectedSimulationRuntime);
        graph.push(
          {
            data: {
              id: `${ dependencyText }-${ nodeText }`,
              source: dependencyText,
              target: nodeText,
            },
          },
        );
      }
    }
  }
  return graph;
}

function findMatchingEvents(node, simulationEvents) {
  return simulationEvents.filter(event => {
    return node.text && event.status.startsWith(node.text);
  });
}

function getNodeText(node, selectedSimulationRuntime) {
  return selectedSimulationRuntime.has(node.text) ?
         node.text + (' [' + selectedSimulationRuntime.get(node.text) + ']') :
         node.text;
}

export const defaultNodes = {
  // No Need to Specify New state as that doesn't give any extra information
  CP_LOAD: {text: 'CP Load'},
  DUCSI_LOAD: {text: 'DUCSI Load'},
  // TODO: Implement FRI_LOAD. Temporarily updating UI text to use FRI as part of the migration.
  Fortune_LOAD: {text: 'FRI Load'},
  LIQ_LOAD: {text: 'Liquidation Load'},
  SPOT_LOAD: {text: 'Spot Data Load'},
  BENCHMARK_ADJUSTMENT_LOAD: {text: 'Benchmark Adjustment Load'},
  COPY_DATA: {text: 'Copy Data'},
  ACCURACY_PIPELINE: {text: 'Accuracy Pipeline'},
  RAW_DATA_SYNC: {text: 'Raw Data Sync'},
  VALIDATION: {text: 'Validation'},
  DONE: {text: 'Done'}
};

function setDependencies() {
  if (!VALIDATION.dependencies) {
    COPY_DATA.dependencies = [CP_LOAD, DUCSI_LOAD, Fortune_LOAD, LIQ_LOAD, SPOT_LOAD, BENCHMARK_ADJUSTMENT_LOAD];
    ACCURACY_PIPELINE.dependencies = [COPY_DATA];
    RAW_DATA_SYNC.dependencies = [COPY_DATA];
    VALIDATION.dependencies = [ACCURACY_PIPELINE];
    DONE.dependencies = [VALIDATION];
  }
}

const {Fortune_LOAD, DUCSI_LOAD, LIQ_LOAD, CP_LOAD, SPOT_LOAD, BENCHMARK_ADJUSTMENT_LOAD, COPY_DATA, ACCURACY_PIPELINE, RAW_DATA_SYNC, VALIDATION, DONE} = defaultNodes;

function getColor(simulationEvents) {
  if (!simulationEvents || simulationEvents.length < 1) {
    return 'white';
  }

  let simulationEvent = simulationEvents[1] || simulationEvents[0];

  if (isDone(simulationEvent)) {
    return 'lightgreen';
  } else if (isRunning(simulationEvent)) {
    return 'lightblue';
  } else if (isSkipped(simulationEvent)) {
    return 'lightgrey';
  } else if (isFailed(simulationEvent)) {
    return 'red';
  } else {
    return 'white';
  }
}

function isRunning(simulationEvent) {
  return simulationEvent.status.endsWith(SimulationStatusTypes.RUNNING);
}

function isDone(simulationEvent) {
  if (simulationEvent.status.includes('-')) {
    return simulationEvent.status.endsWith(SimulationStatusTypes.DONE);
  } else {
    return true;
  }
}

function isSkipped(simulationEvent) {
  return simulationEvent.status.endsWith(SimulationStatusTypes.SKIPPED);
}

function isFailed(simulationEvent) {
  return simulationEvent.status.endsWith(SimulationStatusTypes.FAILED);
}



// WEBPACK FOOTER //
// ./src/components/simulator/graph_element_generator.js